import { useEffect, useRef, useCallback } from "react";

// Interactive gradient background - mouse-reactive layered radials on black
// Inspired by Apple/Linear aesthetic with smooth cursor-following light

const FlowFieldCanvas = () => {
  const containerRef = useRef(null);
  const posRef = useRef({ x: 0, y: 0 });
  const targetRef = useRef({ x: 0, y: 0 });
  const rafRef = useRef(null);

  const lerp = useCallback((a, b, t) => a + (b - a) * t, []);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Smooth animation loop - interpolates toward mouse target
    const animate = () => {
      posRef.current.x = lerp(posRef.current.x, targetRef.current.x, 0.06);
      posRef.current.y = lerp(posRef.current.y, targetRef.current.y, 0.06);
      el.style.setProperty("--mx", posRef.current.x.toFixed(1));
      el.style.setProperty("--my", posRef.current.y.toFixed(1));
      rafRef.current = requestAnimationFrame(animate);
    };

    const onPointer = (e) => {
      const rect = el.getBoundingClientRect();
      targetRef.current.x = ((e.clientX - rect.left) / rect.width - 0.5) * 100;
      targetRef.current.y = ((e.clientY - rect.top) / rect.height - 0.5) * 100;
    };

    const onLeave = () => {
      targetRef.current.x = 0;
      targetRef.current.y = 0;
    };

    el.addEventListener("pointermove", onPointer, { passive: true });
    el.addEventListener("pointerleave", onLeave);
    rafRef.current = requestAnimationFrame(animate);

    return () => {
      el.removeEventListener("pointermove", onPointer);
      el.removeEventListener("pointerleave", onLeave);
      cancelAnimationFrame(rafRef.current);
    };
  }, [lerp]);

  return (
    <div ref={containerRef} className="et-interactive-bg">
      {/* Cursor-following spotlight */}
      <div className="et-interactive-bg__spotlight" />
      {/* Layered reactive gradients */}
      <div className="et-interactive-bg__layer et-interactive-bg__layer--1" />
      <div className="et-interactive-bg__layer et-interactive-bg__layer--2" />
      <div className="et-interactive-bg__layer et-interactive-bg__layer--3" />
      {/* Grain */}
      <div className="et-flow-grain" />
    </div>
  );
};

export default FlowFieldCanvas;
